import { styled } from '@abyss/web/tools/styled';

const MainContainer = styled('main', {
  padding: '$md',
  backgroundColor: '$primary2',
  minHeight: '75dvh',
});

const FooterContainer = styled('main', {
  padding: '0',
  backgroundColor: '$primary1',
  marginLeft: '75px',
});

export { MainContainer, FooterContainer };
